/**
 * Код источника реестра — ключ таблицы `source` и строки `config/sources/<brand>.yaml`.
 *
 * ПОЧЕМУ ОТДЕЛЬНЫЙ ЛИСТ ГРАФА ИМПОРТОВ. Код знают двое: реестр источников
 * (`api/source-registry.ts`) и конфиг бренда (`event_watch.events[].sources` — коды источников,
 * где выходят анонсы конференции, `api/brand-config.ts`). Реестр сам импортирует конфиг бренда
 * (`AllowedHost`), и объяви код в одном из них, второй получил бы цикл импорта, который падает
 * на старте обращением к ещё не объявленной константе. Лист без импортов цикла не даёт.
 *
 * Тот же алфавит, что у кода бренда: код источника — ключ таблицы, и в SQL, журнал и UI он
 * уходит дословно.
 */
export const SOURCE_CODE_RE = /^[a-z][a-z0-9_-]{1,31}$/;
